import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import VueCookie from 'vue-cookie';
import VueResource from 'vue-resource';
import VeeValidate from 'vee-validate';
import VModal from 'vue-js-modal';
import Vue2Filters from 'vue2-filters';
import VueMoment from 'vue-moment';
import vSelect from 'vue-select';
import InfiniteLoading from 'vue-infinite-loading';
import { directive as onClickOutside } from 'vue-on-click-outside';
import preventParentScroll from './directives/prevent-parent-scroll.directive';
import focus from './directives/focus.directive';
import chatScroll from './directives/chat-scroll.directive';
import fallbackSrc from './directives/fallback-src.directive';
import App from './app';
import router from './router';
import store from './store';
import { REMOTE_PATHS } from './constants/remote-paths.constant';

if (process.env.NODE_ENV !== 'development') {
  Raven
    .config('https://e5c9513e774a45608b1140b7c7de3a99@sentry.appunite.com/21')
    .addPlugin(RavenVue, Vue)
    .install();
}

Vue.use(VeeValidate);
Vue.use(VueResource);
Vue.use(VueCookie);
Vue.use(VModal);
Vue.use(Vue2Filters);
Vue.use(VueMoment);
Vue.config.productionTip = false;
Vue.directive('on-click-outside', onClickOutside);
Vue.directive('focus', focus);
Vue.directive('chat-scroll', chatScroll);
Vue.directive('fallback-src', fallbackSrc);
Vue.use(preventParentScroll);
Vue.component('v-select', vSelect);
Vue.component('infinite-loading', InfiniteLoading);

Vue.http.interceptors.push((req, next) => {
  next(res => {
    if (!res.ok && res.status === 401) {
      Vue.prototype.$cookie.delete('accessToken');
      window.location.href = `${REMOTE_PATHS.AUTH_PATH}${window.location.pathname}`;
    }
    return res;
  });
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js